import { render } from "./MinorProtection.vue?vue&type=template&id=4183846a&scoped=true"
import script from "./MinorProtection.vue?vue&type=script&lang=js"
export * from "./MinorProtection.vue?vue&type=script&lang=js"

import "./MinorProtection.vue?vue&type=style&index=0&id=4183846a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4183846a"]])

export default __exports__